module.exports = __webpack_public_path__ + "media/images/gallery/constellations/triangulum/tri_oc-70b4312375c178b310622ca6a5a96681.gif";